/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/signInUser.config.json";
import axios from "axios";

export interface ISignInUserMethods extends IPluginMethodMap {
  getSignInUser(args: any, apiURL: string): Promise<any>;
}

export interface HeaderProps {
  headerName: string;
  headerValue: string;
}

export interface SignInProps {
  email: string;
  password: string;
  apiURL: string;
  headers: HeaderProps;
  storeId: string;
}

export class SignInUserService implements IAgentPlugin {
  readonly methods: ISignInUserMethods;
  constructor() {
    this.methods = {
      getSignInUser: this.getSignInUser.bind(this),
    };
  }

  async getSignInUser(args: SignInProps) {
    console.log(`args in sign in user service`, args);
    let headers: any = {};
    headers[args?.headers?.headerName] = args?.headers?.headerValue;
    console.log("login API end point", `${args.apiURL}${config?.signInEP}`);
    try {
      const res = await axios.post(
        `${args.apiURL}${config?.signInEP}`,
        {
          email: args?.email,
          password: args?.password,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...headers,
          },
        }
      );
      if (res?.data) {
        console.log(`loginData`, res?.data);
        return res?.data;
      }
    } catch (err: any) {
      throw err;
    }
  }
}
